import * as Yup from "yup";
export const generalErrorMessage = "Field is required";
export const atLeastOneField = "At least one option must be selected";
export const validationSchemaAdditionalAuth = Yup.object({
  additional_auth_methods: Yup.string().required(generalErrorMessage),
  additional_auth_methods_other: Yup.string().when("additional_auth_methods", {
    is: (value) => value && value === "Other Methods",
    then: () => Yup.string().required(generalErrorMessage),
    otherwise: () => Yup.string().optional(),
  }),
  additional_auth_otp_channels: Yup.string().when("additional_auth_methods", {
    is: (value) => value && value === "One Time Password (OTP)",
    then: () => Yup.string().required(generalErrorMessage),
    otherwise: () => Yup.string().optional(),
  }),
  additional_auth_methods_secondary: Yup.string().required(generalErrorMessage),
  additional_auth_methods_secondary_other: Yup.string().when("additional_auth_methods_secondary", {
    is: (secondary_method) => secondary_method && secondary_method === "Other Methods",
    then: () => Yup.string().required(generalErrorMessage),
    otherwise: () => Yup.string().optional(),
  }),
  additional_auth_feature_additional_auth: Yup.array().of(
    Yup.object().shape({
      feature: Yup.string().optional(),
      enabled: Yup.boolean(),
      alternativeMethod: Yup.string().optional(),
    })
  ).nullable(),
});
export const validationSchemaCardActivation = Yup.object({
  additional_allow_card_activation_using_app: Yup.string().required(generalErrorMessage),
  additional_card_activation_method: Yup.string().when("additional_allow_card_activation_using_app", {
    is: (allowActivation) => allowActivation && allowActivation === "Yes",
    then: () => Yup.string().required(generalErrorMessage),
    otherwise: () => Yup.string().optional(),
  }),
  additional_validations_for_card_activation: Yup.array(Yup.string()).when("additional_allow_card_activation_using_app", {
    is: (validationForActivation) => validationForActivation && validationForActivation === "Yes",
    then: () => Yup.array(Yup.string()).required(generalErrorMessage).min(1, atLeastOneField),
    otherwise: () => Yup.array().optional(),
  }),
  additional_set_pin_after_card_activation: Yup.string().when("additional_allow_card_activation_using_app", {
    is: (setPinForActivation) => setPinForActivation && setPinForActivation === "Yes",
    then: () => Yup.string().required(generalErrorMessage),
    otherwise: () => Yup.string().optional(),
  }),
});
export const validationSchema = Yup.object({
  additional_customer_email_as_user_id: Yup.string().required(generalErrorMessage),
  additional_email_id_on_screen: Yup.string().when("additional_customer_email_as_user_id", {
    is: (emailIDonScreen) => emailIDonScreen && emailIDonScreen === "No",
    then: () => Yup.string().required(generalErrorMessage),
    otherwise: () => Yup.string().optional(),
  }),
  additional_info_for_user_creation: Yup.array(Yup.string()).required(generalErrorMessage).min(1, atLeastOneField),
  additional_provide_agreement_for_customer_acceptance: Yup.string().required(generalErrorMessage),
  additional_authentication_channel_for_user_creation: Yup.string().optional(),
  additional_authentication_channel_for_user_creation_OTP: Yup.string().when("additional_authentication_channel_for_user_creation", {
    is: (additionalChannel) => additionalChannel && additionalChannel === "OTP",
    then: () => Yup.string().required(generalErrorMessage),
    otherwise: () => Yup.string().optional(),
  }),
  additional_authentication_channel_for_user_creation_Profile_Verification: Yup.array(Yup.string()).when("additional_authentication_channel_for_user_creation", {
    is: (additionalChannel) => additionalChannel && additionalChannel === "Profile Verification",
    then: () => Yup.array(Yup.string()).required(generalErrorMessage),
    otherwise: () => Yup.array().optional(),
  }),
  additional_support_additional_authentications: Yup.string().required(generalErrorMessage),
  additional_support_additional_authentications_details: Yup.string().when("additional_support_additional_authentications", {
    is: (supportAdditional) => supportAdditional && supportAdditional === "Yes",
    then: () => Yup.string().required(generalErrorMessage),
    otherwise: () => Yup.string().optional(),
  }),
  additional_provide_agreement_for_customer_acceptance: Yup.string().required(generalErrorMessage),
  additional_agreement_type_for_toggle_control: Yup.string().when("additional_provide_agreement_for_customer_acceptance", {
    is: (agreementAcceptance) => agreementAcceptance && agreementAcceptance === "Yes",
    then: () => Yup.string().required(generalErrorMessage),
    otherwise: () => Yup.string().optional(),
  }),
  additional_agreement_content_type: Yup.string().when("additional_provide_agreement_for_customer_acceptance", {
    is: (agreementAcceptance) => agreementAcceptance && agreementAcceptance === "Yes",
    then: () => Yup.string().required(generalErrorMessage),
    otherwise: () => Yup.string().optional(),
  }),



});
